import { createRoute, useEntityUrl } from 'framework/routing';

export const QUALIFICATION_STRUCTURE_PATH = '/qualification-structure';

export const useQualificationStructureRoute = () => {
  const routes = createRoute({ listRoute: QUALIFICATION_STRUCTURE_PATH, singleEntityRoute: `/:id` });
  return {
    ...routes,
    builderRoute: `${routes.listRoute}/builder`,
    structureListRoute: `${routes.listRoute}/list`,
    targetRuleRoute: `${routes.singleEntityRoute}`,
  };
};

export const useQualificationStructureUrl = () => {
  const urls = useEntityUrl({
    baseLink: QUALIFICATION_STRUCTURE_PATH,
  });

  return {
    ...urls,
    getBuilderUrl: `${urls.getListUrl()}/builder`,
    getStructureListUrl: `${urls.getListUrl()}/list`,
  };
};
